// @source: https://gist.github.com/meain/6440b706a97d2dd71574769517e7ed32
const FUNNY_MESSAGES: Array<string> = [
    '🤡 Generating witty dialog...',
    '🪐 Swapping time and space...',
    '🥄 Bending the spoon...',
    "🦛 Don't think of purple hippos...",
    '⚡️ We need a new fuse...',
    '😃 Have a good day.',
    '🧑‍🎨 The architects are still drafting',
    '🐔 Would you prefer chicken, steak, or tofu?',
    '🛗 ...and enjoy the elevator music...',
    '🧚 Please wait while the little elves draw your map',
    "🚓 Don't worry - a few bits tried to escape, but we caught them",
    '🍟 Would you like fries with that?',
    '🤿 Go ahead -- hold your breath!',
    "🤷 ...at least you're not on hold...",
    '🎶 Hum something loud while others stare',
    '🍋 The server is powered by a lemon and two electrodes.',
    "😝 We're testing your patience",
    '🐰 Follow the white rabbit',
    "🥪 Why don't you order a sandwich?",
    '🛰 While the satellite moves into position',
    '😴 The bits are flowing slowly today',
    "🏴‍☠️ Dig on the 'X' for buried treasure... ARRR!",
    "✍️ It's still faster than you could draw it",
    '🏎 I should have had a V8 this morning.',
    '⏳ My other loading screen is much faster.',
    "👦 Testing on Timmy... We're going to need another Timmy.",
    '🛣 Are we there yet?',
    '🤲 Just count to 10',
    '🃏 Why so serious?',
    "💔 It's not you. It's me.",
    '🧑‍🏫 Counting backwards from Infinity',
    "⚠️ Don't panic...",
    '👽 Do not run! We are your friends!',
    "🔥 Warning: Don't set yourself on fire.",
    "🍪 We're making you a cookie.",
    '🧑‍🔬 Creating time-loop inversion field',
    '🎡 Spinning the wheel of fortune...',
    '🐇 Loading the enchanted bunny...',
    '🧑‍💻 Computing chance of success',
    '👾 All your web browser are belong to us',
    '🤷 I feel like im supposed to be loading something. . .',
    '😆 What do you call 8 Hobbits? A Hobbyte.',
    '🪟 Is this Windows?',
    '🦥 Please wait until the sloth starts moving.',
    "💥 Don't break your screen yet!",
    "🤞 I swear it's almost done.",
    "🧘 Let's take a mindfulness minute...",
    '🦄 Unicorns are at the end of this road, I promise.',
    '✋ Listening for the sound of one hand clapping...',
    "1️⃣ Keeping all the 1's and removing all the 0's...",
    '🎂 Putting the icing on the cake. The cake is not a lie...',
    '🕸 Cleaning off the cobwebs...',
    "ℹ️ Making sure all the i's have dots...",
    '🧙 Granting wishes...',
    "⏱ Time flies when you're having fun.",
    '☕️ Get some coffee and come back in ten minutes..',
    '🐹 Spinning the hamster...',
    '👂 Stay awhile and listen..',
    '🧙‍♂️ You shall not pass! yet..',
    '🛸 Load it and they will come',
    '👹 Convincing AI not to turn evil..',
    '🧑‍🍳 There is no spoon. Because we are not done loading it',
    '🙌 Your left thumb points to the right and your right thumb points to the left.',
    '😱 How did you get here?',
    '👃 Wait, do you smell something burning?',
    '😵‍💫 Computing the secret to life, the universe, and everything.',
    '👈 When nothing is going right, go left!!...',
    "🏖 I love my job only when I'm on vacation...",
    "🥱 I'm not lazy, I'm just relaxed!!",
    '🏢 Why are they called apartments if they are all stuck together?',
    '🗣 Life is Short - Talk Fast!!!!',
    '🤔 Optimism - is a lack of information.....',
    '🔑 Whenever I find the key to success, someone changes the lock.',
    "😬 I've got problem for your solution...",
    '👶 Adults are just kids with money.',
    '🤨 I think I am, therefore, I am. I think.',
    '🤼 A kiss is like a fight, with mouths.',
    '✨ May the forks be with you',
    '💻 We are not liable for any broken screens as a result of waiting.',
    '📞 Hello IT, have you tried turning it off and on again?',
    '🤯 If you type Google into Google you can break the internet',
    '🌠 Space is invisible mind dust, and stars are but wishes.',
    "🐶 I'm going to walk the dog",
    "👷 I didn't choose the engineering life. The engineering life chose me.",
    '👌 Dividing by zero...',
    "👀 If I' not back in five minutes, just wait longer.",
    '🪖 Cracking military-grade encryption...',
    '🧳 Simulating traveling salesman...',
    '📸 Laughing at your pictures-i mean, loading...',
    '🕵️ Looking for sense of humour, please hold on.',
    '☕️ Please wait while the intern refills his coffee.',
    '☕️ Please hold on as we reheat our coffee',
    '🐛 Kindly hold on as we convert this bug to a feature...',
    '🥶 Winter is coming...',
    '🐱 Distracted by cat gifs',
    "😁 Let's hope it's worth the wait",
    '🛒 Ordering 1s and 0s...',
    "😨 Whatever you do, don't look behind you...",
    '📖 Please wait... Consulting the manual...',
    '🤡 Loading funny message...',
    '🐉 Waiting for Daenerys to say all her titles...',
    '😵‍💫 Feel free to spin in your chair',
    "😰 Help, I'm trapped in a loader!",
    '🤣 What is the difference between a hippo and a zippo? One is really heavy, the other is a little lighter',
    '⛏ Mining some bitcoins...',
    '🎚 Initializing the initializer...',
    '🤧 When was the last time you dusted around here?',
    '🎛 Optimizing the optimizer...',
    '🚌 Last call for the data bus! All aboard!',
    "😉 Never let a computer know you're in a hurry.",
    '🧠 A computer will do what you tell it to do, but that may be much different from what you had in mind.',
    '😶‍🌫️ Shovelling coal into the server',
    '😓 Pushing pixels...',
    '⛈ How about this weather, eh?',
    '🧱 Building a wall...',
    '🥔 Everything in this universe is either a potato or not a potato',
    '📤 Updating Updater...',
    '📥 Downloading Downloader...',
    '🤓 Reading Terms and Conditions for you.',
    '✂️ Running with scissors...',
    "🏠 Coffee at my place, tommorow at 10A.M. - don't be late!",
    '💪 Work, work...',
    '🕰 Patience! This is difficult, you know...',
    '😈 Discovering new ways of making you wait...',
    '😇 Your time is very important to us. Please wait while we ignore you...',
    '🍌 Time flies like an arrow; fruit flies like a banana',
    '🤕 Two men walked into a bar; the third ducked...',
    '🏖 Sooooo... Have you seen my vacation photos yet?',
    '☑️ TODO: Insert elevator music',
    '🏃 Still faster than Windows update',
    '🥸 Please wait while the minions do their work',
    '🏋️ Doing the heavy lifting',
    "🤥 We're working very Hard .... Really",
    '🛏 Waking up the minions',
    '🙄 You are number 2843684714 in the queue',
    '🦄 Feeding unicorns...',
];

export { FUNNY_MESSAGES };
